/** Three lines. The icon set's "menu" glyph is a boxed list, which is not the
 *  hamburger a thumb expects at the corner of a phone screen. */
export function Hamburger() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}
